import { IsDefined } from 'class-validator';

export interface PreferenceDataDto {
	preferenceId: number;
	preferenceName: string | null;
	preferenceSetId: number;
	preferenceSetName: string | null;
	value: string | null;
}

export type GetDefaultPreferenceResponseDto =
	| {
			success: true;
			data: PreferenceDataDto;
	  }
	| {
			success: false;
			error: string;
	  };

/**
 * Represents any JSON-serializable value.
 */
export type JsonValue =
	| string
	| number
	| boolean
	| null
	| Array<JsonValue>
	| { [key: string]: JsonValue };

export class UpdatePreferenceRequestDto {
	@IsDefined({ message: 'Value is required' })
	public value!: JsonValue;
}

export interface UpdatePreferenceResponseDto {
	success: boolean;
	error?: string;
}
